module.exports = __webpack_public_path__ + "6ff9e55ae551ed853fc8f3f1f8225c11.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/head/wasistgoldencity.jpg
// module id = 642
// module chunks = 0